import api from '~services/axios';

export default {
  // 审核-客户审核客户类型
  apiGetClientType: params => api.get('/api/common/query/category', { params }),

  // 审核-客户审核列表
  apiGetClientAuditList: params => api.get('/api/crmCustomerApproval/query/approve/list', { params }),

  // 审核-客户审核查看、审核数据
  apiGetClientAuditDetail: params => api.get('/api/crmCustomerApproval/query/approve/detail', { params }),

  // 审核-联系人审核列表
  apiGetAuditContactsList: params => api.get('/api/crmCustomerApproval/query/customer/convert', { params }),

  // 审核-客户审核通过
  apiPassClientAudit: params => api.post('/api/crmCustomerApproval/approval/pass', params),

  // 审核-客户审核驳回
  apiRefuseClientAudit: params => api.post('/api/crmCustomerApproval/approval/unpass', params),

  // 审核-客户删除
  apiHandleDeleteAudit: params => api.post('/api/crmCustomerApproval/delete', params),
};
